import { useQuery } from "react-query";

import { useOrg, useTimeLookbackRange } from "@hooks";

import { fetchCategorySummaries } from "../api";

export const useCategorySummaries = (reposFilter: string[]) => {
  const org = useOrg();
  const { tlr } = useTimeLookbackRange();

  return useQuery(
    ["CategorySummaries", org, tlr, reposFilter],
    () => fetchCategorySummaries(org!.id, tlr, reposFilter),
    {
      enabled: !!org,
    }
  );
};
